export enum STORAGE_KEY {
    IS_LOGGED_IN = 'isLoggedIn',
    REFRESH_TOKEN = 'refreshToken',
    TOKEN_EXPIRE_TIME = 'token_expire_time',
    TOKEN = 'token',
    USER = 'user',
    GEE_TEST = 'geetest',
    EMAIL_LOGIN = 'emailLogin',
    EMAIL_DATA = 'emaildata',
    EMAIL = 'email',
    PHONE_DATA = 'phonedata',
    FORM_DATA_VERIFY_OTP = 'formDataVerifyOtp'
}

export enum APP_CONSTANTS {
    TIMEOUT = 3000,
    /**
     * Pagination Constants
     */
    NEWS_PAGE_LIMIT = 24,
    DETAIL_PAGE_NEWS_LIMIT = 48,
    TABLE_PAGE_LIMIT = 21,
    SHORT_NEWS_PAGE_LIMIT = 6,
    MAX_PAGINATION_ELEMENTS = 5,

    /**
     * Socket Constants
     */

    DEFAULT_PAIR_TYPE = 'trade',
    COIN_PRICE_ROOM = 'coinPrice',
    COIN_PAIR_PRICE_ROOM = 'coinPairPrice',
    PRICE_EVENT = 'price',
    ACCEPTED = 'accepted',
    DECLINED = 'declined',

    /**
     * Default values
     */
    DEFAULT_PAIRED_CURRENCY = 'USDT',
    DEFAULT_PAGE_TITLE = 'Research | ixfi',

    /**
     * Numerical Constants
     */
    ONE_HUNDRED = 100,
    ONE_THOUSAND = 1000,
    ONE_MILLION = 1000000,
    ONE_BILLION = 1000000000,
    XXL_DEVICE_RESOLUTION = 1400,

    /**
     * ITB Constants
     */
    ITB_API_KEY = 'xKxSbTrA5X40dKJswZAT18lNgVyszfQz4EfjIw52'
}

export type IxfiResearchApi =
    | 'CRYPTO_NEWS'
    | 'MARQUEE_COINS'
    | 'ALL_IXFI_COINS'
    | 'TRENDING_COINS'
    | 'COIN_CATEGORIES'
    | 'HISTORICAL_DATA'
    | 'COIN_DETAIL'
    | 'MARKET_PAIRS'
    | 'COIN_INFO_JSON'
    | 'COIN_PRICE_JSON'
    | 'WALLET_PAIRS'
    | 'COIN_PAIRS'
    | 'CRYPTO_NEWS_DETAIL'
    | 'NEWS_PUBLISHERS';
